module.exports = __webpack_public_path__ + "static/media/NPNTServices.fd263380.svg";